import { makeStyles } from '@mui/styles';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FieldChangeHandlerContext } from '@mui/x-date-pickers/internals';
import { FieldProps } from 'formik';
import moment from 'moment';

const useDateFieldStyles = makeStyles({
  date: {
    marginTop: '16px',
    marginBottom: '8px',
    width: '100%',
  },
});

interface CustomProps {
  placeholder: string;
  minDateMessage?: string;
  // allow a custom onChange from parent (e.g. to call Formik's setFieldValue from above)
  onChange?: (value: any, context?: any) => void;
}

type FormDateFieldProps = FieldProps & CustomProps;

function FormDateField({ field, form, placeholder, minDateMessage, onChange: propOnChange, ...props }: FormDateFieldProps) {
  const classes = useDateFieldStyles();
  const internalOnChange = (value: any, _context: FieldChangeHandlerContext<any>) => {
    // Accepts Date, string, null, or Moment/dayjs depending on config
    if (!form) return; // defensive
    if (value && typeof value === 'object' && typeof value.toDate === 'function') {
      // Moment or dayjs
      const formatted = moment(value).format('DDMMYYYY');
      form.setFieldValue(field.name, value.toDate());
    } else if (value instanceof Date) {
      form.setFieldValue(field.name, value);
    } else if (typeof value === 'string' || value === null) {
      form.setFieldValue(field.name, value);
    }
  };

  const onChange = (value: any, context: FieldChangeHandlerContext<any>) => {
    // If a parent provided an onChange (we now pass setFieldValue from parents), prefer it.
    if (typeof propOnChange === 'function') {
      try {
        propOnChange(value, context);
        return;
      } catch (e) {
        // fall through to internal handler
      }
    }
    internalOnChange(value, context);
  };

  return (
    <DateTimePicker
      label={placeholder}
      format="DD/MM/YYYY"
      {...field}
      className={classes.date}
      onChange={onChange}
      disablePast={!!minDateMessage}
    />
  );
}

export default FormDateField;
